import React from "react"
import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router-dom"
import { Skeleton } from "@material-ui/lab"
import { Paper, makeStyles, Theme } from "@material-ui/core"

import { RootState } from "redux/store"
import { Status } from "shared/types/status"

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    height: "100%",
    margin: "0.75rem",
    borderRadius: "8px",
  },
  skeleton: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
}))

export const PrivateRoute: React.FC = () => {
  const classes = useStyles()
  const user = useSelector((state: RootState) => state.authorisation.user)
  const loginStatus = useSelector(
    (state: RootState) => state.authorisation.loginStatus
  )

  if (loginStatus === Status.idle || loginStatus === Status.loading) {
    return (
      <Paper className={classes.container}>
        <Skeleton
          className={classes.skeleton}
          variant="rect"
          animation="wave"
        />
      </Paper>
    )
  }

  if (user?.role_id.role_name !== "Administrator") {
    return <Navigate to="/project" replace />
  }

  return <Outlet />
}

export default PrivateRoute
